import { useId } from 'react';

const Trust = ({ ...props }) => {
  const uid = useId();
  const gradientId = `trust-gradient-${uid}`;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='22' height='24' viewBox='0 0 22 24' fill='none' {...props}>
      <path
        d='M0.286133 3.46686L10.9995 0V24C3.34699 20.7997 0.286133 14.6664 0.286133 11.2003V3.46686Z'
        fill='#0500FF'
      />
      <path
        d='M21.7137 3.46686L11.0004 0V24C18.6529 20.7997 21.7137 14.6664 21.7137 11.2003V3.46686Z'
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1='18.8679'
          y1='-1.68063'
          x2='10.8399'
          y2='23.6925'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.02' stopColor='#0000FF' />
          <stop offset='0.08' stopColor='#0094FF' />
          <stop offset='0.16' stopColor='#48FF91' />
          <stop offset='0.42' stopColor='#0094FF' />
          <stop offset='0.68' stopColor='#0038FF' />
          <stop offset='0.9' stopColor='#0500FF' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Trust;
